import { useEffect, useRef } from 'react';

/**
 * ChatBot page component that loads and displays the chatbot widget
 */
const ChatBot: React.FC = () => {
  const initialized = useRef(false);
  /*
   * Načitanie scriptu
   */
  useEffect(() => {
    if (initialized.current) return; // Skip ak je už inicializovaný
    initialized.current = true;
    const script = document.createElement('script');
    script.src = 'https://chat-bot-app-production.up.railway.app/api/widget/cmnyit1ul001a8kau515e847s';
    script.setAttribute('data-mode', 'embed');
    script.setAttribute('data-container', 'botforge-chat');
    script.async = true;

    document.body.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <div
      id="botforge-chat"
      style={{
        height: '100vh',
        width: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        touchAction: 'none',
      }}
    />
  );
};

export default ChatBot;
